export default __webpack_public_path__ + "f96fdce0821f17bb33f9c7797c265cef.jpg";